import { Button, Divider } from "@mui/material";
import React, { useEffect, useState } from "react";
import { formatDoctorNames, getEventDataForCustomerRating } from "../../../utils/genericUtils";

import { CloseIcon } from "../../../components/Icons";
import { Image } from "../../../components/AvatarCustom/AvatarCustom.style";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { ReviewRating } from "../../../components";
import { toastMessageActions } from "../../../state/request";
import { useAppointmentRatingStore } from "../../../hooks";
import { useAppointmentStore } from "../../../hooks/redux-hooks/appointment-store/appointment.store";
import { useDispatch } from "react-redux";
import { useModal } from "../../../context/ModalContext";
import { useUserStore } from "../../../hooks/redux-hooks/user-store/user.store";
import { userActivityLogger } from "../../../utils/mixpanel";

const PostToGoogleModal = () => {
  const { closeModal } = useModal();
  const dispatch = useDispatch();

  const [mapLocationUrl, setMapLocationUrl] = useState<string>("");
  const { userRating, setAppointmentRatingNull } =
   useAppointmentRatingStore();
  const { user } = useUserStore();
  const { appointmentPlaceId }=useModal();

  const { appointmentDetails, setAppointmentDetails } = useAppointmentStore();

  const { petName, day, month, resources, time } = getEventDataForCustomerRating(appointmentDetails);

  const appointmentInfo = {
    pet_name: petName || "",
    doctor_name: formatDoctorNames(resources) || "",
    date: `${month} ${day}` || "",
    time_slot: time || "",
  };


  useEffect(() => {
    if (user && user.location && (appointmentPlaceId !== "")) {
      const googleMapUrl =
      `https://search.google.com/local/writereview?placeid=${appointmentPlaceId}`;

      setMapLocationUrl(googleMapUrl);
    }
  }, [user]);

  useEffect(() => {
    if (userRating.stepOneFeedback.length) {
      dispatch(toastMessageActions.setGlobalAlert({ severity: "success",
        message: "Your review has been successfully copied to the clipboard." }));
      navigator.clipboard.writeText(userRating.stepOneFeedback);
    }
  }, []);

  const handleCloseModal = () => {
    closeModal();
    setAppointmentRatingNull();
    setAppointmentDetails(null);
  };

  const googleMapRedirection = () => {
    userActivityLogger(MIXPANEL_EVENTS.USER_CLICKS_POST_REVIEW_TO_GOOGLE,
      {
        rating_value: userRating?.starRating,
        current_step: "google review",
        ...appointmentInfo,
      });
    setTimeout(()=>{
      window.open(mapLocationUrl, "_blank");
      setAppointmentRatingNull();
      setAppointmentDetails(null);
      handleCloseModal();
      dispatch(toastMessageActions.setGlobalAlert({ severity: "success",
        message: "Thank you for your review!" }));
    }, 1500);
  };

  return (
    <div className="w-full px-1 sm:px-4 py-1 !h-full flex flex-col justify-between overflow-y-auto">
      <div className="flex flex-col gap-3">
        <div className="flex w-full justify-end">
          <CloseIcon
            onClick={handleCloseModal}
            className="text-black cursor-pointer mt-1"
          />
        </div>
        <div className="flex flex-col gap-6 items-center self-stretch flex-1 mb-2">
          {/* details */}
          <div id="appointment-details-section" className="flex items-start gap-3 self-stretch">

            <div id="details" className="flex flex-col items-start gap-1 flex-1">
              <h2 className="text-lg sm:text-2xl font-bold leading-6">
              Post your review to Google
              </h2>
              <div className="text-sm sm:text-base leading-5">
                {userRating.stepOneFeedback.length > 0 &&
                <span>{"We’ve copied your review to your clipboard to make posting easier. "}</span>}
                <span>Your feedback helps others discover the quality care at GoodVets.</span>
              </div>
            </div>
            <div className="max-w-[100px] max-h-[56px]">
              <Image src="/assets/icons/GoogleReview.png" alt="Google Logo" />
            </div>
          </div>

          <Divider className="!w-full !m-0 border !border-gray-3" />

          {/* Your REVIEW */}

          <div className="flex flex-col items-start self-stretch gap-3 p-4 rounded-lg bg-white
          border border-taupe-50">
            <h3 className="text-sm font-bold leading-5">Your review</h3>
            <ReviewRating readonly iconHeight={userRating.stepOneFeedback.length ? 24 : 36}
              iconWidth={userRating.stepOneFeedback.length ? 24 : 36} value={userRating.starRating}/>
            {<div className="max-h-fit">
              <p className="text-base leading-6 text-wrap">{userRating.stepOneFeedback}</p>
            </div>}
          </div>
          {/* YOUR REVIEW END */}

        </div>
      </div>
      <div>
        <Button variant="contained" color="primary"
          className="!font-bold"
          fullWidth onClick={googleMapRedirection}>
            Post to Google
        </Button>
      </div>
    </div>
  );
};

export default PostToGoogleModal;
